import React from 'react';
import { Link } from 'react-router-dom';
import BlogArticleLayout, { blogStyles as s } from './BlogArticleLayout';

function BlogArticleErreursFrequentes() {
  return (
    <BlogArticleLayout
      tag="Cybersécurité"
      title="Les erreurs de cybersécurité les plus fréquentes en PME"
      date="22 octobre 2026"
      ctaTitle="Vérifiez si votre entreprise commet l'une de ces erreurs"
      ctaText="Le diagnostic passe en revue ces points automatiquement et vous indique lesquels s'appliquent à votre situation."
    >
      <p style={s.intro}>
        Ce ne sont presque jamais des attaques sophistiquées qui mettent une PME en difficulté, mais une
        poignée d'erreurs récurrentes, souvent connues, rarement corrigées faute de priorité. En voici huit
        parmi les plus fréquentes.
      </p>

      <h2 style={s.h2}>1. Des sauvegardes jamais testées</h2>
      <p>Une sauvegarde existe, mais personne n'a jamais vérifié qu'elle pouvait réellement être restaurée. On le découvre souvent le jour où c'est trop tard.</p>

      <h2 style={s.h2}>2. Des mots de passe partagés ou réutilisés</h2>
      <p>Un même mot de passe utilisé sur plusieurs comptes, ou partagé entre plusieurs salariés, transforme une seule fuite en compromission généralisée.</p>

      <h2 style={s.h2}>3. L'absence de double authentification</h2>
      <p>Sur les comptes sensibles (messagerie, banque en ligne, hébergement), l'absence de double authentification laisse la porte ouverte au moindre mot de passe compromis.</p>

      <h2 style={s.h2}>4. Des prestataires jamais vérifiés</h2>
      <p>Confier ses données à un prestataire sans jamais s'interroger sur ses propres pratiques de sécurité reporte le risque sans le supprimer.</p>

      <h2 style={s.h2}>5. Une équipe jamais sensibilisée</h2>
      <p>La majorité des incidents commencent par une erreur humaine. Sans sensibilisation, même basique, cette porte d'entrée reste grande ouverte — voir notre article sur le
        {' '}<Link to="/blog/phishing-entreprise-reconnaitre-prevenir" style={s.link}>phishing en entreprise</Link>.</p>

      <h2 style={s.h2}>6. Des mises à jour repoussées</h2>
      <p>Reporter une mise à jour « parce que ça marche déjà » laisse ouvertes des vulnérabilités pourtant déjà corrigées par l'éditeur.</p>

      <h2 style={s.h2}>7. Aucune procédure en cas d'incident</h2>
      <p>Découvrir en pleine crise qui prévenir et comment réagir fait perdre un temps précieux — voir notre article
        {' '}<Link to="/blog/que-faire-apres-cyberattaque" style={s.link}>Que faire après une cyberattaque</Link>.</p>

      <h2 style={s.h2}>8. Tout miser sur l'antivirus</h2>
      <p>
        Un antivirus est utile, mais il ne remplace ni les sauvegardes, ni la gestion des accès, ni la
        sensibilisation des équipes. La sécurité repose sur plusieurs couches complémentaires, pas sur un
        outil unique perçu comme suffisant.
      </p>

      <p>
        Aucune de ces erreurs n'est complexe à corriger isolément. La difficulté est de savoir lesquelles vous
        concernent réellement et dans quel ordre les traiter — c'est précisément ce que produit un diagnostic
        structuré.
      </p>
    </BlogArticleLayout>
  );
}

export default BlogArticleErreursFrequentes;
